import PortalIdParser from 'PortalIdParser';
const getBaseUrl = () => '/embedded-academy-ui';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export const getIsStaticPublicUrl = () => window.location.pathname === '/embedded-academy-ui/static';
export const getIsStandaloneWidget = () => window.top === window;
export const appendQueryParams = (url, params) => {
  const urlObj = new URL(url, window.location.origin);
  for (const [key, value] of Object.entries(params)) {
    urlObj.searchParams.set(key, value);
  }
  return urlObj.toString();
};